export const setModalV2Visible = ({commit}, payload) => {
  commit('SET_MODAL_V2_VISIBLE', payload)
}
